var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-menu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    clipPath: "url(#clip-menu)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(-45.422 -49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(45.421 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M68.221,69.556h-21.6a1.222,1.222,0,0,0,0,2.444h21.6a1.222,1.222,0,0,0,0-2.444Zm-21.6-17.112h21.6a1.222,1.222,0,0,0,0-2.444h-21.6a1.222,1.222,0,0,0,0,2.444Zm21.6,7.334h-21.6a1.222,1.222,0,0,0,0,2.444h21.6a1.222,1.222,0,0,0,0-2.444Z",
    transform: "translate(-45.421 -50)",
    fill: "#34495e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.a5025c9586a96a76b35b3cf17a613d99.svg";
export { ForwardRef as ReactComponent };